import { useTranslation } from "react-i18next";

export const useSelectFormularioChecklist = () => {
    const { t } = useTranslation();
    const SELECT_FORMULARIO_CHECKLIST = [
        {
            value: 11,
            label: t('select_seleccionar_unidad'),
        },
        {
            value: 12,
            label: t('select_input_odometro_actual'),
        },
        {
            value: 13,
            label: t('select_input_odometro_proximo_checklist'),
        },
        {
            value: 14,
            label: t('select_fecha_actual_checklist'),
        },
        {
            value: 15,
            label: t('select_fecha_proximo_checklist'),
        },
        {
            value: 16,
            label: t('select_seleccionar_conductor'),
        },
        {
            value: 17,
            label: t('select_seleccionar_area'),
        },
        {
            value: 18,
            label: t('select_seleccionar_tipo_checklist'),
        },
        {
            value: 19,
            label: t('select_seleccionar_tipo_vehiculo'),
        },
        {
            value: 20,
            label: t('select_seleccionar_marca_vehiculo'),
        },
        {
            value: 21,
            label: t('select_seleccionar_tipo_carroceria'),
        },
        {
            value: 22,
            label: t('select_seleccionar_tipo_combustible'),
        },
        {
            value: 23,
            label: t('select_seleccionar_ciudad'),
        },
        {
            value: 24,
            label: t('select_ultimo_odometro_registrado'),
        },
        {
            value: 25,
            label: t('select_ultima_temperatura_registrada'),
        },
        {
            value: 30,
            label: t('select_seleccionar_nivel_combustible'),
        },
        {
            value: 31,
            label: t('select_seleccionar_motivo'),
        },
        {
            value: 32,
            label: t('select_input_numero_de_conocimiento'),
        },
        {
            value: 36,
            label: t('select_geocerca_origen'),
        },
        {
            value: 37,
            label: t('select_geocerca_destino'),
        },
        {
            value: 38,
            label: t('input_fecha_programada_de_viaje'),
        },
        {
            value: 39,
            label: t('input_odometro_proximo_mantenimiento'),
        },
        {
            value: 41,
            label: t('select_seleccionar_personal_transportar'),
        },
        {
            value: 42,
            label: t('select_ruta'),
        },
        {
            value: 43,
            label: t('select_turno'),
        },
        {
            value: 44,
            label: t('select_input_ruta'),
        },
        {
            value: 45,
            label: t('select_input_actividad'),
        },
        {
            value: 46,
            label: t('select_ida_vuelta_el_mismo_dia'),
        },
        {
            value: 47,
            label: t('input_fecha_hora_partida'),
        },
        {
            value: 48,
            label: t('input_fecha_hora_llegada'),
        },
        {
            value: 49,
            label: t('input_total_kilometros'),
        },
        {
            value: 50,
            label: t('input_contacto_destino'),
        },
        {
            value: 51,
            label: t('input_proposito_del_viaje'),
        },
        {
            value: 52,
            label: t('input_telefono'),
        },
        {
            value: 53,
            label: t('input_empresa'),
        },
        {
            value: 54,
            label: t('input_type'),
        },
        {
            value: 55,
            label: t('input_propietario'),
        },
    ];

    return SELECT_FORMULARIO_CHECKLIST;
};

export const FORMULARIO_CHECKLIST = {
    SELECCIONAR_CONDUCTOR: 16,
    ODOMETRO_PROXIMO_MANTENIMIENTO: 39,
    PERSONAL_TRANSPORTAR: 41,
    RUTA: 42,
    TURNO: 43,
};

export const AVANZADO_FORMULARIO_CHECKLIST = {
    VALIDAR_CONDUCTOR: 35,
    VALIDAR_ODOMETRO_PROXIMO_MANTENIMIENTO: 40,
};